import React, { Fragment, useEffect } from "react";
import CreateBannerForm from "../BannerForm/BannerForm";
import Header from "../../subheader/Header";

const ViewBanner = () => {
  useEffect(() => {
    document.title = "Banner";
  }, []);
  return (
    <Fragment>
      <div className="vendor-page-right banner-page-desktop">
        <Header heading={"View Banner"} search={false} filters={null} />
        <div className="right-content banner-page-content-container">
          <div className="form">
            <CreateBannerForm readOnly={true} state="view" />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ViewBanner;
